import * as t from 'io-ts';

const MarketingQuestionIO = t.interface({
    id: t.string,
    name: t.string,
    possibleAnswers: t.array(t.string),
    active: t.boolean,
    fileName: t.string,
    uploadedAt: t.string,
    universe: t.string
});

export const ResponseGetQuestionsIO = t.array(MarketingQuestionIO);

export const ResponseAddQuestionIO = MarketingQuestionIO;

export const ResponseUpdateQuestionIO = MarketingQuestionIO;
